import React from 'react';
import { Link } from 'react-router-dom';
import { FaBullhorn, FaCheckCircle, FaVolumeUp, FaExpandArrowsAlt, FaShieldAlt, FaUserTie } from 'react-icons/fa';
import './Services.css';

const PASystem = () => {
  const features = [
    'Professional sound reinforcement systems',
    'Conference room audio solutions',
    'Auditorium and theater PA systems',
    'Indoor and outdoor speaker installations',
    'Wireless microphone systems',
    'Digital mixing consoles and processors',
    'Background music and paging systems',
    'Complete system integration and commissioning'
  ];

  const benefits = [
    {
      icon: <FaVolumeUp />,
      title: 'Crystal Clear Communication',
      description: 'Ensure every word is heard clearly with professional-grade PA systems designed for optimal speech intelligibility.'
    },
    {
      icon: <FaExpandArrowsAlt />,
      title: 'Scalable Solutions',
      description: 'From small meeting rooms to large auditoriums, we design systems that scale to your specific venue requirements.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Reliable Performance',
      description: 'Enterprise-grade equipment and redundant systems ensure your PA system works flawlessly when you need it most.'
    },
    {
      icon: <FaUserTie />,
      title: 'Professional Installation',
      description: 'Expert design, installation, and calibration by certified audio engineers for perfect coverage and sound quality.'
    }
  ];

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section className="service-hero">
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <FaBullhorn className="service-hero-icon" />
          <h1>PA System Design & Installation</h1>
          <p>
            Professional Public Address systems for conferences, auditoriums, theaters, houses of worship,
            educational institutions, and commercial spaces. We deliver crystal-clear sound reinforcement
            solutions tailored to your venue's unique acoustics and requirements.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              <h2>Professional PA System Solutions</h2>
              <p>
                A Public Address (PA) system is essential for any venue that requires clear, intelligible
                sound coverage for speech or music. Our expert team designs and installs custom PA solutions
                that ensure every seat in your venue receives optimal audio quality.
              </p>
              <p>
                We specialize in both permanent installations and portable PA systems for various applications
                including conference rooms, auditoriums, theaters, places of worship, educational facilities,
                sports venues, and outdoor events. Our systems integrate seamlessly with video conferencing,
                recording equipment, and building automation systems.
              </p>
              <p>
                From initial acoustic analysis and system design to installation, calibration, and training,
                we handle every aspect of your PA system implementation. Our solutions use industry-leading
                brands and technologies to ensure reliability, performance, and ease of use.
              </p>
            </div>
            <div className="content-image">
              <img 
                src="https://images.unsplash.com/photo-1598653222000-6b7b7a552625?w=800&h=600&fit=crop&q=80" 
                alt="PA System Installation" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="service-features">
        <div className="container">
          <h2>Our PA System Capabilities</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div className="feature-item" key={index}>
                <FaCheckCircle />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="service-benefits">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose Our PA Solutions?</h2>
            <p>Professional expertise and reliable solutions for perfect sound coverage</p>
          </div>
          <div className="values-grid">
            {benefits.map((benefit, index) => (
              <div className="value-card" key={index}>
                <div className="value-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="service-gallery">
        <div className="container">
          <h2>Our PA System Installations</h2>
          <div className="gallery-grid">
            <img src="https://images.unsplash.com/photo-1598653222000-6b7b7a552625?w=600&h=400&fit=crop&q=80" alt="Conference Room PA System" />
            <img src="https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=600&h=400&fit=crop&q=80" alt="Auditorium Sound System" />
            <img src="https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=600&h=400&fit=crop&q=80" alt="Concert PA Setup" />
            <img src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=600&h=400&fit=crop&q=80" alt="Professional Audio Equipment" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="container">
          <h2>Ready for a Professional PA System?</h2>
          <p>Contact us today to discuss your sound reinforcement requirements</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">
              Get a Consultation
            </Link>
            <a href="tel:+919876543210" className="btn btn-secondary">
              Call Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PASystem;
